import React, { useMemo, useRef, useState } from 'react';
import { motion } from "framer-motion"
import { Text, ITextProps } from '@fluentui/react/lib/Text';
import { card } from '../App';
import { ActionButton, Checkbox, ChoiceGroup, IButtonStyles, IComboBoxOption, PrimaryButton, ProgressIndicator, TextField } from '@fluentui/react';
import { Controller, useForm } from 'react-hook-form';
import { useRecaptcha } from 'react-recaptcha-hook';
import Results from '../Results/Results';


const Form: React.FC<FormProps> = (props: FormProps) => {

    const [question, setQuestion] = useState<number>(0);


    const btnStyles: IButtonStyles = {
        rootHovered: {
            backgroundColor: "rgb(255,95,80)",
            border: 0
        },
        rootPressed: {
            backgroundColor: "#1a1b4a",
            border: 0
        },
        root: {
            fontSize: '18px',
            padding: '20px',
            border: 0,
            borderRadius: '10px',
            width: '100%'
        }
    };

    const btnStylesNext: IButtonStyles = {
        rootHovered: {
            backgroundColor: "rgb(255,95,80)",
            border: 0
        },
        rootPressed: {
            backgroundColor: "#1a1b4a",
            border: 0
        },
        flexContainer: {
            flexDirection: 'row-reverse'
        },
        root: {
            fontSize: '18px',
            padding: '20px',
            border: 0,
            borderRadius: '10px',
            width: '100%'
        }
    };

    const { register, handleSubmit, clearErrors, getValues, watch, control, formState: { errors } } = useForm();

    const watchAllFields = watch();

    const execute = useRecaptcha({ sitekey: "6LeOOggcAAAAAMgoemU5E7Um5NRToQRdmxWdxk-B", hideDefaultBadge: true });

    const nextButtonEnabled = () => {
        if (!watchAllFields['moeite']) {
            return true;
        }
        else if (question === 0 && watchAllFields['moeite'].length > 0)
            return false;
        else if (question === 1 && watchAllFields['takenuren'].length > 0)
            return false;
        else if (question === 2 && watchAllFields['werkuren'].length > 0)
            return false;
        else if (question === 3 && watchAllFields['vrijetijduren'].length > 0)
            return false;
        else if (question === 4)
            return false;
        else
            return true;
    }

    const showPhoneNumberField = (watchAllFields['Contact'] === true);

    return (
        <div className='cardsection' style={{ textAlign: 'start', minHeight: '400px' }}>
            <form id="hook-form">
                <div style={{ minHeight: '340px' }}>
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: question === 0 ? 1 : question > 0 ? 0.3 : 0 }}
                        transition={{ delay: 0 }}
                        style={{ margin: '20px auto', maxWidth: '420px', display: question === 0 ? 'unset' : 'none' }}
                    >
                        <Controller
                            name="moeite"
                            control={control}
                            defaultValue=""
                            rules={{ required: true }}
                            render={({ field }) =>
                                <>

                                    <motion.div
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        transition={{ delay: 0 }}

                                        style={{ textAlign: 'left', margin: '0 auto', fontSize: '14px' }}>

                                        <motion.div
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            transition={{ delay: 0 }}
                                            style={{ textAlign: 'left' }}
                                        >
                                            <Text>
                                                Je hebt van <b>{props.results.filter(r => r.result === true).length}</b> {props.results.filter(r => r.result === true).length === 1 ? 'taak' : ' taken'} aangegeven dat je die wel eens doet voor een ander:
                                                <ul style={{ listStyle: '' }}>
                                                    {props.results.filter(r => r.result === true).map(r => {
                                                        return (
                                                            <li key={r.name}>{r.name}</li>
                                                        );
                                                    })}
                                                </ul>
                                            </Text>
                                        </motion.div>

                                        <motion.div
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            transition={{ delay: 0 }}
                                        >
                                            <Text>
                                                Je bent daardoor mantelzorger. Misschien wist je dit al, of misschien is dit nieuw voor je.
                                            </Text>
                                        </motion.div>
                                        <br /><br />
                                        {/* <br /><br /><br />
                                        <motion.div
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            transition={{ delay: 2.5 }}
                                        >
                                            <PrimaryButton iconProps={{ iconName: 'Forward' }} styles={btnStyles} text="Verder" onClick={() => { props.next(); }} />
                                        </motion.div> */}
                                    </motion.div>

                                    {/* <Text variant='large'>
                                        Je hebt aangegeven dat je deze taken allemaal doet voor een ander:
                                        <br />
                                        <Text>
                                            <ul>
                                                {props.results.filter(r => r.result === true).map(r => {
                                                    return (
                                                        <li>{r.name}</li>
                                                    );
                                                })}
                                            </ul>
                                        </Text>
                                    </Text> */}
                                    <ChoiceGroup
                                        label="Hoeveel moeite kosten al deze taken je?"
                                        // required={true}
                                        disabled={question === 5}
                                        onChange={(_e, option) => {
                                            field.onChange(option?.key);
                                            // setQuestion(1);
                                        }}
                                        placeholder="Selecteer een optie"
                                        options={[
                                            { key: '0', text: 'weinig', iconProps: { iconName: 'CircleRing' } }, //, style: { color: 'rgb(235,215,255)' } } },
                                            { key: '1', text: 'neutraal', iconProps: { iconName: 'CircleHalfFull' } }, //, style: { color: 'rgb(235,215,255)' } } },
                                            { key: '2', text: 'veel', iconProps: { iconName: 'CircleFill' } } //, style: { color: 'rgb(235,215,255)' } } }
                                        ]}
                                    />
                                </>
                            }
                        />
                    </motion.div>

                    <motion.div
                        // initial={{ opacity: 0 }}
                        // animate={{ opacity: question === 1 ? 1 : question > 1 ? 0.3 : 0 }}
                        transition={{ delay: 0 }}
                        style={{ margin: '20px auto', maxWidth: '420px', display: question === 1 ? 'unset' : 'none' }}
                    >
                        <Controller
                            name="takenuren"
                            control={control}
                            defaultValue=""
                            rules={{ required: true }}
                            render={({ field }) =>
                                <>
                                    <ChoiceGroup
                                        label="Hoeveel tijd besteed je per week aan die taken?"
                                        // required={true}
                                        disabled={question === 5}
                                        onChange={(_e, option) => {
                                            field.onChange(option?.key);
                                            // setQuestion(2);
                                        }}
                                        placeholder="Selecteer een optie"
                                        options={[
                                            { key: '0', text: '0 - 6 uur' },
                                            { key: '1', text: '7 - 12 uur' },
                                            { key: '2', text: '13 - 24 uur' },
                                            { key: '3', text: 'meer dan 24 uur' }
                                        ]}
                                    />
                                </>
                            }
                        />
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: question === 2 ? 1 : question > 2 ? 0.3 : 0 }}
                        transition={{ delay: 0 }}
                        style={{ margin: '20px auto', maxWidth: '420px', display: question === 2 ? 'unset' : 'none' }}
                    >
                        <Controller
                            name="werkuren"
                            control={control}
                            defaultValue=""
                            rules={{ required: true }}
                            render={({ field }) =>
                                <>
                                    <ChoiceGroup
                                        label="Hoeveel uur per week werk je?"
                                        // required={true}
                                        disabled={question === 5}
                                        onChange={(_e, option) => {
                                            field.onChange(option?.key);
                                            // setQuestion(3);
                                        }}
                                        placeholder="Selecteer een optie"
                                        options={[
                                            { key: '0', text: '0 - 6 uur' },
                                            { key: '1', text: '7 - 12 uur' },
                                            { key: '2', text: '13 - 24 uur' },
                                            { key: '3', text: 'meer dan 24 uur' }
                                        ]}
                                    />
                                </>
                            }
                        />
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: question === 3 ? 1 : question > 3 ? 0.3 : 0 }}
                        transition={{ delay: 0 }}
                        style={{ margin: '20px auto', maxWidth: '420px', display: question === 3 ? 'unset' : 'none' }}
                    >
                        <Controller
                            name="vrijetijduren"
                            control={control}
                            defaultValue=""
                            rules={{ required: true }}
                            render={({ field }) =>
                                <>
                                    <ChoiceGroup
                                        label="Hoeveel uur per week besteed je echt aan jezelf? Bijvoorbeeld door een boek te lezen, te sporten, tv te kijken, met een vriend/vriendin op stap te gaan, breien of gewoon relaxen?"
                                        // required={true}
                                        disabled={question === 5}
                                        onChange={(_e, option) => {
                                            field.onChange(option?.key);
                                            // setQuestion(4);
                                        }}
                                        placeholder="Selecteer een optie"
                                        options={[
                                            { key: '0', text: '0 - 6 uur' },
                                            { key: '1', text: '7 - 12 uur' },
                                            { key: '2', text: '13 - 24 uur' },
                                            { key: '3', text: 'meer dan 24 uur' }
                                        ]}
                                    />
                                </>
                            }
                        />
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: question === 4 ? 1 : question > 4 ? 0.3 : 0 }}
                        transition={{ delay: 0 }}
                        style={{ margin: '20px auto', maxWidth: '420px', display: question === 4 ? 'unset' : 'none' }}
                    >
                        <div style={{ margin: '10px 0' }}>
                            <Text>Fijn dat je de test hebt ingevuld. Laat je naam en e-mailadres achter, dan krijg je het resultaat per mail toegestuurd.</Text>
                        </div>


                        <Controller
                            name="Naam"
                            control={control}
                            defaultValue=""
                            rules={{ required: true }}
                            render={({ field }) =>
                                <TextField
                                    errorMessage={errors['Naam'] ? 'Dit veld is verplicht' : undefined}
                                    onChange={field.onChange}
                                    required={true}
                                    disabled={question === 5}
                                    label="Naam"
                                />
                            }
                        />

                        <Controller
                            name="E-Mail"
                            control={control}
                            defaultValue=""
                            rules={{
                                required: true,
                                pattern: {
                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                    message: "Controleer het e-mail adres"
                                }
                            }}
                            render={({ field }) =>
                                <TextField
                                    errorMessage={errors['E-Mail'] ? 'Controleer het e-mail adres' : undefined}
                                    onChange={field.onChange}
                                    required={true}
                                    disabled={question === 5}
                                    label="E-mail"
                                />
                            }
                        />

                        {props.applicationMode === 0 &&
                            <>
                                <Controller
                                    name="Contact"
                                    control={control}
                                    defaultValue={false}
                                    rules={{ required: false }}
                                    render={({ field }) =>
                                        <div>
                                            <Checkbox
                                                label="Ik heb een vraag rondom de zorg voor mijn naaste, ik wil graag dat iemand van Fello contact met mij opneemt."
                                                styles={{ root: { margin: '20px 0' } }}
                                                onChange={field.onChange}
                                                required={true}
                                                disabled={question === 5}
                                            />
                                        </div>
                                    }
                                />


                                {showPhoneNumberField &&
                                    <Controller
                                        name="Telefoonnummer"
                                        control={control}
                                        defaultValue=""
                                        rules={{ required: showPhoneNumberField }}
                                        render={({ field }) =>
                                            <TextField
                                                style={{ display: watchAllFields['Contact'] === true ? 'unset' : 'none' }}
                                                errorMessage={errors['Telefoonnummer'] ? 'Dit veld is verplicht' : undefined}
                                                onChange={field.onChange}
                                                required={true}
                                                disabled={question === 5}
                                                label="Telefoonnummer"
                                            />
                                        }
                                    />
                                }

                                <Controller
                                    name="Informatie"
                                    control={control}
                                    defaultValue={false}
                                    rules={{ required: false }}
                                    render={({ field }) =>
                                        <div>
                                            <Checkbox
                                                label="Je krijgt altijd de uitslag toegestuurd, ook zonder vinkje. Zet je hier wel een vinkje, dan geef je aan dat je het goed vindt dat we je e-mailadres gebruiken voor het toesturen van informatie over mantelzorg en Fello. Dit doen we maximaal 6 keer per jaar."
                                                styles={{ root: { margin: '20px 0' } }}
                                                onChange={field.onChange}
                                                required={true}
                                                disabled={question === 5}
                                            />
                                            {/* <Text variant='small'>
                                        Natuurlijk gaan wij heel zorgvuldig om met jouw gegevens. We delen alleen de resultaten van de scan op organisatieniveau zodat je werkgever een beeld krijgt bij de impact van mantelzorg op alle medewerkers. De resultaten zijn nooit te herleiden naar één persoon of afdeling. Wanneer je een traject start met een Fello coach, weet hij/zij natuurlijk wat er bij jou speelt, en heeft hij/zij bepaalde gegevens van jou nodig. Maar niets daarvan wordt bij Fello opgeslagen. En het komt ook niet bij jouw werkgever terecht.
                                    </Text> */}
                                        </div>
                                    }
                                />
                            </>
                        }

                        <Text>
                            Door op verzenden te klikken geef je aan kennis te hebben genomen van ons <a target="_blank" href="https://info.getfello.com/privacystatement/">privacystatement</a>.
                        </Text>
                        <br /><br />
                        <Text variant='small'>
                            Velden met een * zijn verplicht
                        </Text>
                        <br /><br />
                        {/* <Controller
                            name="Akkoord"
                            control={control}
                            defaultValue={[]}
                            rules={{ required: true }}
                            render={({ field }) =>
                                <Checkbox
                                    styles={{ root: { margin: '10px 0' } }}
                                    // disabled={contactFormSent !== 0}
                                    onChange={field.onChange}
                                    required={true}
                                    onRenderLabel={() => {
                                        return <div>
                                            Natuurlijk gaan we heel zorgvuldig om met jouw gegevens. Ik heb kennis genomen van het <a target="_blank" href="https://info.getfello.com/privacystatement/">privacystatement</a>. <span style={{ color: 'rgb(164, 38, 44)' }}>*</span>

                                        </div>
                                    }}

                                />
                            }
                        /> */}

                        {errors && errors['Akkoord'] &&
                            <div>
                                <Text style={{ color: 'rgb(164, 38, 44)' }}>Je moet akkoord gaan om het formulier te verzenden</Text>
                            </div>
                        }

                        <br />


                        {/* <PrimaryButton styles={btnStyles} text="Verzenden"
                        disabled={question === 5}
                        onClick={(e) => {
                            handleSubmit(
                                async (d) => {
                                    setQuestion(5);
                                    console.log(d);
                                    await new Promise(r => setTimeout(r, 2000));
                                    props.saved(true);
                                },
                                (errors => {
                                    console.log(errors);
                                })
                            )();
                        }}
                    /> */}
                        {question === 5 &&
                            <ProgressIndicator />
                        }
                    </motion.div>
                </div>
                <div style={{ display: 'flex' }}>
                    <div style={{ width: '50%' }}>
                        {question > 0 &&
                            <PrimaryButton iconProps={{ iconName: 'back' }}
                                styles={btnStyles} style={{}} text='Vorige'
                                disabled={question === 5}
                                onClick={() => { setQuestion(question - 1) }}
                            />
                        }
                    </div>
                    {/* <div style={{ width: '110px', textAlign: 'center' }}>
                        {canGoBack &&
                            <ActionButton styles={{ root: {} }} iconProps={{ iconName: 'Undo' }} disabled={false} text='Stap terug' onClick={() => { }} />
                        }
                    </div> */}
                    <div style={{ width: '50%' }}>
                        <PrimaryButton
                            iconProps={{ iconName: question > 3 ? '' : 'forward' }}
                            disabled={nextButtonEnabled()}
                            styles={btnStylesNext}
                            style={{ margin: '0 0 0 10px' }} text={question === 4 ? 'Verzenden' : 'Volgende'}


                            onClick={() => {
                                if (question === 4) {
                                    handleSubmit(
                                        async (d) => {

                                            const params = (new URL(window.location.href)).searchParams;
                                            const code = params.get('code');

                                            setQuestion(5);
                                            // console.log(d);

                                            const token = await execute('TakenTinder');

                                            const mantelzorgTEST = 'https://prod-188.westeurope.logic.azure.com:443/workflows/af39f7d384a8439eafdfbfeb22b9859c/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=PnMZ4srp70LcvAEAaaPSqNSa5ys5CiM3HP7ogdYLTI8';
                                            const mantelzorgPROD = 'https://prod-237.westeurope.logic.azure.com:443/workflows/6dc221127f9b4c6a98edb0bd749ecae5/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=Is2lVTl8ozuOCM-t8KLRzQyC2xOCoEVJMEaPO1G94lg';
                                            const mantelzorgPRPROD = 'https://prod-199.westeurope.logic.azure.com:443/workflows/21c88a11d41d41ee8efc692a3e7741c5/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=tKQ1J6ZF9HpX7hPu-YOFMlQpJpoQ86l06QZlF0QjtbE';

                                            var url = null;
                                            switch (window.location.hostname.toLowerCase()) {
                                                case ('localhost'): {
                                                    url = mantelzorgTEST;
                                                    break;
                                                }
                                                case ('mantelzorgtest.fello.nl'): {
                                                    url = mantelzorgPROD;
                                                    break;
                                                }
                                                case ('mantelzorgtest-pr.fello.nl' ) : {
                                                    url = mantelzorgPRPROD;
                                                    break;
                                                }
                                                case ('fellodemositestorage.z6.web.core.windows.net'): {
                                                    url = mantelzorgTEST;
                                                    break;
                                                }
                                                default: {
                                                    url = mantelzorgTEST;
                                                }
                                            }

                                            // console.log(url);

                                            fetch(url, {
                                                method: 'POST',
                                                headers: {
                                                    'content-type': 'application/json'
                                                },
                                                body: JSON.stringify({
                                                    token: token,
                                                    code: code,
                                                    cards: props.results,
                                                    answers: d,
                                                    account: props.account?.key
                                                })
                                            }).then((res) => {
                                                if (res.status === 200) {
                                                    props.saved(true);
                                                } else {
                                                    alert('Er is iets misgegaan. Probeer het later nog eens.')
                                                }
                                            })


                                        },
                                        (errors => {
                                            console.log(errors);
                                        })
                                    )
                                        ();
                                }
                                else {
                                    setQuestion(question + 1)
                                }

                            }} />
                    </div>
                </div>
            </form>
        </div>
    );

}

export default Form;


interface FormProps {
    results: card[];
    account?: IComboBoxOption;
    saved: (succes: boolean) => void;
    applicationMode: number;
}